import { CommonGAssets } from '@hhgtech/hhg-components/gAssets'
import { Button, Text } from '@hhgtech/hhg-components/mantine'
import { BoxProps, Stack } from '@mantine/core'
import { useIntl } from 'react-intl'
import { shallow } from 'zustand/shallow'

import { useAirPopulationStore } from 'state/airPopulation'

import useStyles from './index.styles'
import { Layout } from '../Layout'

export const ErrorScreenGeneral = ({
  styles,
  classNames,
  ...props
}: BoxProps) => {
  const { retryFetchInitData } = useAirPopulationStore(
    (state) => ({
      retryFetchInitData: state.retryFetchInitData,
    }),
    shallow,
  )
  const { formatMessage: f } = useIntl()
  const { classes } = useStyles(undefined, {
    name: 'AirPopulation__ErrorScreenGeneral',
    styles,
    classNames,
  })

  return (
    <Layout
      {...props}
      classNames={{
        root: classes.root,
        colLeft: classes.colLeft,
        colRight: classes.colRight,
      }}
      colLeft={
        <Stack spacing={16} className={classes.info}>
          <Text size="h3">
            {f({ id: 'airPopulation.notFound.title', defaultMessage: 'Opps!' })}
          </Text>
          <Text size="p2" variant="secondary">
            {f({
              id: 'airPopulation.notFound.description',
              defaultMessage:
                'We couldn’t load the Air Pollution Tool right now. Please try again later or refresh the page.',
            })}
          </Text>
          <Button
            size="lg"
            variant="secondary"
            onClick={retryFetchInitData}
            data-event-category="AQI"
            data-event-action="retry AQI display"
            data-event-label="click to retry"
          >
            {f({ id: 'airPopulation.retryButton.label' })}
          </Button>
        </Stack>
      }
      colRight={
        <img
          loading="lazy"
          alt="Result not found"
          width={120}
          height={120}
          src={CommonGAssets.getAssetPath('airPopulation/not-found.svg')}
        />
      }
    />
  )
}
